export const environment = {
    API_URL: "https://insura-transaccional-backend.jamsoftco.com/api/",
    production: false,
    version: "5.1.0 (Jam)"
};